import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ResourceCard } from "~/components/ui/resource-card";
import { notFound } from "@tanstack/react-router";
import { coachQueryOptions } from "~/lib/query-options";

export const Route = createFileRoute("/$username/_profile/resources/")({
  loader: async ({ context, params }) => {
    // Use the same query options as the main profile
    const coach = await context.queryClient.ensureQueryData(
      coachQueryOptions.byUsername(params.username),
    );

    if (!coach || !coach.resources || 0 === coach.resources.length) {
      throw notFound();
    }

    return { coach };
  },
  component: ResourcesPage,
});

function ResourcesPage() {
  const { username } = Route.useParams();
  const { coach } = Route.useLoaderData();

  const { data: queryCoach } = useQuery({
    ...coachQueryOptions.byUsername(username),
    initialData: coach,
  });

  if (!queryCoach?.profile) {
    return "Coach not found.";
  }

  return (
    <div className="grid gap-8 md:grid-cols-2">
      {queryCoach.resources.length ? (
        queryCoach.resources.map((resource) => (
          <ResourceCard
            className="h-full"
            key={resource.id}
            resource={resource}
            coachUsername={queryCoach.username}
          />
        ))
      ) : (
        <p>No resources available.</p>
      )}
    </div>
  );
}
